import {styled, Typography} from "@mui/material"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {StandardDeliveryContainer} from "../../component"

export const TotalValue = styled(Typography)`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
`

export const DeliveryContainer = styled(StandardDeliveryContainer)`
    > span {
        font-family: ${({theme}) => `${theme.uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-size: ${({theme}) => `${theme.uxfabric.global.body2.fontSize}`};
        font-weight: ${({theme}) => `${theme.uxfabric.global.body2.fontWeight}`};
        line-height: ${({theme}) => `${theme.uxfabric.global.body2.lineHeight}`};
        letter-spacing: ${({theme}) => `${theme.uxfabric.global.body2.letterSpacing}`}px;
    }
`
